import React from "react";
import PropTypes from "prop-types";
import { TextInput } from "@opendate-app/setlist";
import { formatCurrencySymbol } from "../../shared/teamCurrencyFormatting";

const TWO_DECIMALS = /^\d+(\.\d{1,2})?$/;

export const formatPriceInput = (value) => {
  if (value === "" || value == null) return "";
  const text = String(value).trim();
  return TWO_DECIMALS.test(text) ? Number(text).toFixed(2) : text;
};

export default function PriceInput({ label, value, onChange, currencyCode, hint, error, required, ...inputProps }) {
  return (
    <TextInput
      {...inputProps}
      label={label}
      required={required}
      type="number"
      min="0"
      step="0.01"
      inputMode="decimal"
      leadingText={formatCurrencySymbol(currencyCode)}
      placeholder="0.00"
      hint={hint}
      error={error}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={() => {
        const formatted = formatPriceInput(value);
        if (formatted !== String(value ?? "")) onChange(formatted);
      }}
    />
  );
}

PriceInput.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  currencyCode: PropTypes.string,
  hint: PropTypes.node,
  error: PropTypes.node,
  required: PropTypes.bool,
};
